module.exports = __webpack_public_path__ + "assets/3250d8a4-c9b7-4e3c-bca2-822e7f601901.19124bb0.svg";